/* tslint:disable */
/* eslint-disable */
/**
 * Pet Profile A Service
 * Pet Profile A Layer Service For more information or information on how this data maps to the kryios data see [here](https://chewyinc.atlassian.net/wiki/spaces/MPROD/pages/1957927091/Pet+Property+to+Data+Mapping)
 *
 * The version of the OpenAPI document: 1.0
 * Contact: DL-IT_Pet_Profile@chewy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PetAllergyModel } from './PetAllergyModel';
import {
    PetAllergyModelFromJSON,
    PetAllergyModelFromJSONTyped,
    PetAllergyModelToJSON,
} from './PetAllergyModel';
import type { PetBreedModel } from './PetBreedModel';
import {
    PetBreedModelFromJSON,
    PetBreedModelFromJSONTyped,
    PetBreedModelToJSON,
} from './PetBreedModel';
import type { PetMedicalConditionModel } from './PetMedicalConditionModel';
import {
    PetMedicalConditionModelFromJSON,
    PetMedicalConditionModelFromJSONTyped,
    PetMedicalConditionModelToJSON,
} from './PetMedicalConditionModel';
import type { PetMedicationAllergyModel } from './PetMedicationAllergyModel';
import {
    PetMedicationAllergyModelFromJSON,
    PetMedicationAllergyModelFromJSONTyped,
    PetMedicationAllergyModelToJSON,
} from './PetMedicationAllergyModel';
import type { PetMedicationModel } from './PetMedicationModel';
import {
    PetMedicationModelFromJSON,
    PetMedicationModelFromJSONTyped,
    PetMedicationModelToJSON,
} from './PetMedicationModel';
import type { PetTypeModel } from './PetTypeModel';
import {
    PetTypeModelFromJSON,
    PetTypeModelFromJSONTyped,
    PetTypeModelToJSON,
} from './PetTypeModel';

/**
 * 
 * @export
 * @interface PetAttributeDataModel
 */
export interface PetAttributeDataModel {
    /**
     * 
     * @type {Array<PetTypeModel>}
     * @memberof PetAttributeDataModel
     */
    types: Array<PetTypeModel>;
    /**
     * 
     * @type {Array<PetBreedModel>}
     * @memberof PetAttributeDataModel
     */
    breeds: Array<PetBreedModel>;
    /**
     * 
     * @type {Array<PetAllergyModel>}
     * @memberof PetAttributeDataModel
     */
    allergies: Array<PetAllergyModel>;
    /**
     * 
     * @type {Array<PetMedicationModel>}
     * @memberof PetAttributeDataModel
     */
    medications: Array<PetMedicationModel>;
    /**
     * 
     * @type {Array<PetMedicationAllergyModel>}
     * @memberof PetAttributeDataModel
     */
    medicationAllergies: Array<PetMedicationAllergyModel>;
    /**
     * 
     * @type {Array<PetMedicalConditionModel>}
     * @memberof PetAttributeDataModel
     */
    medicalConditions: Array<PetMedicalConditionModel>;
}

/**
 * Check if a given object implements the PetAttributeDataModel interface.
 */
export function instanceOfPetAttributeDataModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "types" in value;
    isInstance = isInstance && "breeds" in value;
    isInstance = isInstance && "allergies" in value;
    isInstance = isInstance && "medications" in value;
    isInstance = isInstance && "medicationAllergies" in value;
    isInstance = isInstance && "medicalConditions" in value;

    return isInstance;
}

export function PetAttributeDataModelFromJSON(json: any): PetAttributeDataModel {
    return PetAttributeDataModelFromJSONTyped(json, false);
}

export function PetAttributeDataModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): PetAttributeDataModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'types': ((json['types'] as Array<any>).map(PetTypeModelFromJSON)),
        'breeds': ((json['breeds'] as Array<any>).map(PetBreedModelFromJSON)),
        'allergies': ((json['allergies'] as Array<any>).map(PetAllergyModelFromJSON)),
        'medications': ((json['medications'] as Array<any>).map(PetMedicationModelFromJSON)),
        'medicationAllergies': ((json['medicationAllergies'] as Array<any>).map(PetMedicationAllergyModelFromJSON)),
        'medicalConditions': ((json['medicalConditions'] as Array<any>).map(PetMedicalConditionModelFromJSON)),
    };
}

export function PetAttributeDataModelToJSON(value?: PetAttributeDataModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'types': ((value.types as Array<any>).map(PetTypeModelToJSON)),
        'breeds': ((value.breeds as Array<any>).map(PetBreedModelToJSON)),
        'allergies': ((value.allergies as Array<any>).map(PetAllergyModelToJSON)),
        'medications': ((value.medications as Array<any>).map(PetMedicationModelToJSON)),
        'medicationAllergies': ((value.medicationAllergies as Array<any>).map(PetMedicationAllergyModelToJSON)),
        'medicalConditions': ((value.medicalConditions as Array<any>).map(PetMedicalConditionModelToJSON)),
    };
}

